import React, { lazy, Suspense } from 'react';
import { Switch, Route, useLocation } from 'react-router-dom';
import { Redirect } from 'react-router';
import { Spin } from 'antd';

// import * as Containers from '../Containers';

const UserDetail = lazy(() => import('../Containers/UserDetail'));
const TeamMember = lazy(() => import('../Containers/TeamMember'));
const BranchSetting = lazy(() => import('../Containers/Branch'));
const VisaStatus = lazy(() => import('../Containers/VisaStatus'));
const VisaType = lazy(() => import('../Containers/VisaType'));
const PotentialClientStatus = lazy(() => import('../Containers/PotentialClientStatus'));
const CustomQuestionnaire = lazy(() => import('../Containers/Questionnaire'));
const QuestionnaireList = lazy(() => import('../Containers/QuestionnaireList'));
const PreviewQuestionnaire = lazy(() => import('../Containers/PreviewQuestionnaire'));
const Profile = lazy(() => import('../Containers/ClientProfile'));
const Partner = lazy(() => import('../Containers/Partner'));
const Qualification = lazy(() => import('../Containers/ClientQualification'));
const FileNotes = lazy(() => import('../Containers/FileNotes'));
const SubmitQuestionnaire = lazy(() => import('../Containers/SubmitQuestionnaire'));
const UpdateQuestionnaire = lazy(() => import('../Containers/UpdateQuestionnaire'));
const ClientQuestionnaire = lazy(() => import('../Containers/ClientQuestionnaire'));
const VisaFlow = lazy(() => import('../Containers/ClientVisa'));
const Admission = lazy(() => import('../Containers/ClientAdmission'));
const Accounts = lazy(() => import('../Containers/Accounts'));
const ClientList = lazy(() => import('../Containers/ClientList'));
const Employer = lazy(() => import('../Containers/ClientEmployer'));
const JobHistory = lazy(() => import('../Containers/EmployerJobHistory'));
const FamilyMember = lazy(() => import('../Containers/FamilyMember'));
const Activities = lazy(() => import('../Containers/Activities'));
const Reports = lazy(() => import('../Containers/Reports'));
const EmployerReports = lazy(() => import('../Containers/EmployerReports'));
const Companies = lazy(() => import('../Containers/Companies'));
const BranchDetail = lazy(() => import('../Containers/BranchDetail'));
const KnockKnockCompanies = lazy(() => import('../Admin/KnockKnockCompanies'));
const KnockKnockPortal = lazy(() => import('../KnockKnock/KnockKnockPortal'));
const KnockKnockDocsPage = lazy(() => import('../Admin/KnockKnockDocsPage'));
const PotentialClientReport = lazy(() => import('../Containers/PotentialClientReport'));
const VisaReport = lazy(() => import('../Containers/VisaReports'));
const Mail = lazy(() => import('../Containers/Mail'));
const PCleintCustomQuestionnaire = lazy(() => import('../Containers/PQuestionnaire'));
const CalendarSync = lazy(() => import('../Containers/CalendarSync'));
const OtherInfo = lazy(() => import('../Containers/ClientOtherInfo'));
const UpdateMappProperty = lazy(() => import('../Containers/UpdateMappProperty'));
const AddAgent = lazy(() => import('../Containers/AddAgent'));
const Deals = lazy(() => import('../Containers/Deals'));
const VisaBranchCountry = lazy(() => import('../Containers/VisaBranchCountry'));
const TimeTrackingMain = lazy(() => import('../Containers/TimeTrackingMain'));
const LoginImage = lazy(() => import('../Containers/LoginImage'));
const CompanyUsersList = lazy(() => import('../Containers/CompanyUsersList'));
const TimeTrackingReport = lazy(() => import('../Containers/TimeTrackingReport'));
const Agents = lazy(() => import('../Containers/Agents'));
const OutlookIntegrationNew = lazy(() => import('../Containers/OutlookIntegrationNew'));
const DocumentSync = lazy(() => import('../Containers/DocumentSync'));
const CaseManagement = lazy(() => import('../Containers/CaseManagement'));
const ChecklistCategory = lazy(() => import('../Containers/ChecklistCategory'));
const AddChecklist = lazy(() => import('../Containers/AddChecklist'));
const Chats = lazy(() => import('../Containers/Chats'));
const ClientSummary = lazy(() => import('../Containers/ClientSummary'));
const DashboardPotentialClientReport = lazy(() => import('../Containers/DashboardPotentialClient'));
const DashboardReminders = lazy(() => import('../Containers/DashboardReminders'));
const DashboardEmployers = lazy(() => import('../Containers/DashboardEmployers'));
const DashboardStudent = lazy(() => import('../Containers/DashboardStudent'));
const DashboardBi = lazy(() => import('../Containers/DashboardBi'));
const OutlookIntegration = lazy(() => import('../Containers/OutlookIntegration'));
const Supervisor = lazy(() => import('../Containers/Supervisor'));
const SupervisorBatchesStudents = lazy(() => import('../Containers/SupervisorBatchesStudents'));
const PrintCase = lazy(() => import('../Containers/PrintCase'));
const GmailIntegration = lazy(() => import('../Containers/GmailIntegration'));

const AddNewClient = lazy(() => import('../Clients/AddNewClient'));
const AllClients = lazy(() => import('../Containers/AllClients'));
const ClientDocument = lazy(() => import('../Containers/ClientDocuments'));
const ClientAccount = lazy(() => import('../Clients/ClientAccount'));
const Inquiry = lazy(() => import('../PotentialClient/Inquiry'));
const PotentialEmployer = lazy(() =>
  import('../PotentialClient/PotentialEmployer/PotentialEmployer')
);
const PotenialClientSummary = lazy(() => import('../Dashboard/PotenialClient'));
const AccountSetting = lazy(() => import('../AccountSetting/AccountSetting'));
const TimeTracking = lazy(() => import('../Reports/TimeTracking'));
const EmployerManagementHead = lazy(() => import('../Containers/EmployerManagement'));
const WebAssessment = lazy(() => import('../PotentialClient/WebAssessment'));
const WebInquiryDetailed = lazy(() => import('../PotentialClient/WebInquiryDetailed'));
const WebInquiryLinkDetailed = lazy(() => import('../PotentialClient/WebInquiryLinkDetailed'));
const WebInquiryLinkBasic = lazy(() => import('../PotentialClient/WebInquiryLinkBasic'));
const WebAssessmentLink = lazy(() => import('../PotentialClient/WebAssessmentLink'));
const BasicAssessmentLink = lazy(() => import('../PotentialClient/BasicAssessmentLink'));
const DailyTaskReminders = lazy(() => import('../Containers/MyDailyTasksReminder'));
const CompletedTasks = lazy(() => import('../MyDailyTasksReminders/CompletedTasks'));
const CommissionReminder = lazy(() => import('../MyDailyTasksReminders/CommissionReminders'));
const WorkType = lazy(() => import('../TimeTracking/WorkType'));
const VisaTypePrice = lazy(() => import('../TimeTracking/VisaTypePrice'));
const ServiceType = lazy(() => import('../TimeTracking/ServiceType'));
const NzFormList = lazy(() => import('../VisaForm/NZFormList'));
const AusFormList = lazy(() => import('../VisaForm/AusFormList'));
const TechnicalSupport = lazy(() => import('../TechnicalSupport/TechnicalSupport'));
const Meetings = lazy(() => import('../Meetings/Meetings'));
const ClientEmail = lazy(() => import('../Containers/ClientEmail'));
const StudentList = lazy(() => import('../SchoolManagement/StudentList'));
const Schools = lazy(() => import('../SchoolManagement/Schools'));
const SchoolManagementLayout = lazy(() => import('../SchoolManagement/SchoolManagementLayout'));
const NewInvoice = lazy(() => import('../SchoolManagement/NewInvoice'));
const SchoolAccounts = lazy(() => import('../SchoolManagement/Invoices'));
const ClientTags = lazy(() => import('../Containers/AccountSettings'));
const DocumentTypes = lazy(() => import('../Containers/DocumentTypes'));
const EzmCommonDocs = lazy(() => import('../Containers/EzmCommonDocs'));
const ReminderSetting = lazy(() => import('../Containers/ReminderSetting'));
const SettingTimeTracking = lazy(() => import('../Containers/TimeTracking'));
const VisaUpdateNotification = lazy(() => import('../Containers/VisaUpdateNotification'));
const DocumentChecklist = lazy(() => import('../Containers/DocumentChecklist'));
const SettingFileNotes = lazy(() => import('../Containers/SettingFileNotes'));
const ContractSettings = lazy(() => import('../Containers/ContractSettings'));
const LetterTemplates = lazy(() => import('../Containers/LetterTemplates'));
const MailChamp = lazy(() => import('../Containers/MailChimp'));
const AgentPortalDocuments = lazy(() => import('../Containers/DocumentsSettings'));
const CheckMyVisaDocs = lazy(() => import('../Containers/CheckMyVisaDocs'));
const EmailContent = lazy(() => import('../Containers/EmailContent'));
const QuestionnaireSettings = lazy(() => import('../Containers/QuestionnaireSettings'));
const DefaultFontSettings = lazy(() => import('../Containers/DefaultFontSettings'));
const TimeZoneSettings = lazy(() => import('../Containers/TimeZoneSettings'));
const SignatureSettings = lazy(() => import('../Containers/SignatureSettings'));
const DailyEmailSettings = lazy(() => import('../Containers/DailyEmailSettings'));
const DocumentView = lazy(() => import('../Containers/DocumentView'));
const ImapSettings = lazy(() => import('../Containers/ImapSettings'));
const ContactUs = lazy(() => import('../Containers/EmployerCheckList'));
const AddNewPotentialClient = lazy(() => import('../PotentialClient/AddNewPotentialClient'));
const PotentialClient = lazy(() => import('../PotentialClient/PotentialClient'));
const ImportPotentialClient = lazy(() => import('../PotentialClient/ImportPotentialClient'));
const PotentialClientsStatus = lazy(() => import('../PotentialClient/PotentialClientsStatus'));
const SignUpForm = lazy(() => import('../Components/SignUpForm'));
const ChatLists = lazy(() => import('../Chats/ChatList'));
const PrivacyPolicy = lazy(() => import('../PrivacyPolicy/PrivacyPolicy'));
const Xero = lazy(() => import('../Xero/Xero'));
const XeroModule = lazy(() => import('../Xero/XeroAddAccount'));
const XeroAddAccountLayout = lazy(() => import('../Xero/XeroAddAccountLayout'));
const Invoices = lazy(() => import('../Xero/Invoices'));
const AddInvoiceToXero = lazy(() => import('../Xero/AddInvoiceToXero'));
const AddSchoolInvoiceToXero = lazy(() => import('../Xero/AddSchoolInvoiceToXero'));
const AddPaymentsToXero = lazy(() => import('../Xero/AddPaymentsToXero'));
const Listing = lazy(() => import('../Accounts/Templates/Listing'));
const AddTemplateInvoice = lazy(() => import('../Clients/AddTemplateInvoice'));
const ComingSoon = lazy(() => import('../Components/ComingSoon'));
const Videos = lazy(() => import('../Videos'));
const PurchaseSubscription = lazy(() => import('../Common/PurchaseMessage.js'));
const UploadStudentData = lazy(() => import('../Supervisor/Students/UploadStudentsData.js'));
const HubspotIntegration = lazy(() => import('../Containers/HubspotIntegration.js'));
const WorkflowStudio = lazy(() => import('../AIWorkflow/WorkflowStudio'));
const WorkflowExecutions = lazy(() => import('../AIWorkflow/WorkflowExecutions'));

// import GmailIntegration from "../AccountSetting/UserLevelSettings/ImapSettings/GmailIntegration.js";

const LoadingFallback = () => (
  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
    <Spin size="large" tip="Loading..." />
  </div>
);

const LazyRoute = ({ path, exact, component: Component, render, ...rest }) => (
  <Route
    path={path}
    exact={exact}
    {...rest}
    render={(props) => (
      <Suspense fallback={<LoadingFallback />}>
        {Component ? <Component {...props} /> : render?.(props)}
      </Suspense>
    )}
  />
);

export default function Routes() {
  const location = useLocation();

  return (
    // <Suspense fallback={<LoadingFallback />}>
    //   <Switch>
    //     {/*<Route path="/login" component={User} />*/}
    //     {/* <Route key={location.key} path="/dashboardBI" component={DashboardBi} /> */}
    //     <Route exact path="/dashboardBI" render={() => <DashboardBi key={location.key} />} />
    //     <Route key={location.key} path="/all-clients" component={AllClients} />
    //     <Route key={location.key} path="/visa-flow" component={VisaFlow} />
    //     <Route key={location.key} path="/documents" component={ClientDocument} />
    //     <Route key={location.key} path="/employer" component={Employer} />
    //     <Route key={location.key} path="/job-history" component={JobHistory} />
    //     <Route key={location.key} path="/qualification" component={Qualification} />
    //     <Route key={location.key} path="/client-account" component={ClientAccount} />
    //     <Route key={location.key} path="/potential-client" component={Inquiry} />
    //     <Route
    //       key={location.key}
    //       path="/import-potential-client"
    //       component={ImportPotentialClient}
    //     />
    //     <Route key={location.key} path="/add-potential-client" component={AddNewPotentialClient} />
    //     <Route
    //       key={location.key}
    //       path="/update-potential-client"
    //       component={AddNewPotentialClient}
    //     />
    //     {/*<Route path="/permanent-client" component={AddNewClient} />*/}
    //     <Route
    //       exact
    //       key={location.key}
    //       path="/potential-client/potential-clients"
    //       component={PotentialClient}
    //     />
    //     <Route
    //       exact
    //       key={location.key}
    //       path="/potential-client/potential-clients-status"
    //       component={PotentialClientsStatus}
    //     />
    //     <Route
    //       exact
    //       key={location.key}
    //       path="/potential-client/potential-employer"
    //       component={PotentialEmployer}
    //     />
    //     <Route key={location.key} exact path="/add-new-client" component={AddNewClient} />
    //     <Route key={location.key} path="/file-notes" component={FileNotes} />
    //     <Route key={location.key} path="/activities" component={Activities} />
    //     {/* <Route key={location.key} path="/profile" component={Profile} /> */}
    //     <Route exact path="/profile" render={() => <Profile key={location.key} />} />
    //     <Route exact path="/partner-profile" render={() => <Partner key={location.key} />} />
    //     <Route key={location.key} exact path="/dashboard" component={ClientSummary} />
    //     <Route
    //       key={location.key}
    //       exact
    //       path="/dashboard/potentialclient"
    //       component={DashboardPotentialClientReport}
    //     />
    //     <Route
    //       key={location.key}
    //       exact
    //       path="/dashboard/reminders"
    //       component={DashboardReminders}
    //     />
    //     <Route
    //       key={location.key}
    //       exact
    //       path="/dashboard/employers"
    //       component={DashboardEmployers}
    //     />
    //     <Route key={location.key} exact path="/dashboard/student" component={DashboardStudent} />
    //     <Route key={location.key} path="/Case-Management-All" component={CaseManagement} />
    //     <Route key={location.key} path="/Case-management" component={CaseManagement} />
    //     <Route key={location.key} path="/AddChecklist" component={AddChecklist} />
    //     <Route key={location.key} path="/Checklists" component={ChecklistCategory} />
    //     <Route
    //       // key={location.key}
    //       path="/super-user-setting"
    //       component={UserDetail}
    //     />
    //     <Route key={location.key} path="/team-member" component={TeamMember} />
    //     <Route key={location.key} path="/add-agent" component={AddAgent} />
    //     <Route key={location.key} path="/branch-settings" component={BranchSetting} />
    //     <Route key={location.key} path="/visa-type" component={VisaType} />
    //     <Route key={location.key} path="/visa-branch-country" component={VisaBranchCountry} />
    //     <Route key={location.key} path="/visa-statuses" component={VisaStatus} />
    //     <Route
    //       key={location.key}
    //       path="/potential-client-status"
    //       component={PotentialClientStatus}
    //     />
    //     <Route key={location.key} exact path="/account-setting" component={ImapSettings} />
    //     <Route
    //       key={location.key}
    //       exact
    //       path="/account-setting-gmail"
    //       component={GmailIntegration}
    //     />
    //     <Route
    //       key={location.key}
    //       exact
    //       path="/account-setting-hubspot"
    //       component={HubspotIntegration}
    //     />
    //     <Route key={location.key} path="/account-settings" component={AccountSetting} />
    //     <Route key={location.key} path="/reports" component={Reports} />
    //     <Route
    //       key={location.key}
    //       path="/potential-clients-report"
    //       component={PotentialClientReport}
    //     />
    //     <Route key={location.key} path="/visa-report" component={VisaReport} />
    //     <Route key={location.key} path="/time-tracking" component={TimeTrackingMain} />
    //     <Route key={location.key} path="/time-tracking-report" component={TimeTrackingReport} />
    //     <Route key={location.key} path="/employer-reports" component={EmployerReports} />
    //     <Route key={location.key} path="/agents" component={Agents} />
    //     <Route key={location.key} path="/agent-clients" component={ComingSoon} />
    //     <Route key={location.key} path="/video-tutorials" component={Videos} />
    //     <Route key={location.key} path="/useful-links" component={ComingSoon} />
    //     <Route key={location.key} path="/employer-management" component={EmployerManagementHead} />
    //     <Route key={location.key} path="/web-assessment" component={WebAssessment} />
    //     <Route key={location.key} path="/web-inquiry-detailed" component={WebInquiryDetailed} />
    //     <Route
    //       key={location.key}
    //       path="/web-inquiry-link-detailed"
    //       component={WebInquiryLinkDetailed}
    //     />
    //     <Route key={location.key} path="/web-inquiry-link-basic" component={WebInquiryLinkBasic} />
    //     <Route key={location.key} path="/web-assessment-link" component={WebAssessmentLink} />
    //     <Route key={location.key} path="/basic-assessment-link" component={BasicAssessmentLink} />
    //     <Route key={location.key} path="/tasks-and-reminders" component={DailyTaskReminders} />
    //     <Route
    //       key={location.key}
    //       path="/tasks-and-reminders/tasks-to-do"
    //       component={DailyTaskReminders}
    //     />
    //     <Route
    //       key={location.key}
    //       path="/tasks-and-reminders/completed-tasks"
    //       component={CompletedTasks}
    //     />
    //     <Route
    //       key={location.key}
    //       path="/tasks-and-reminders/commission-reminders"
    //       component={CommissionReminder}
    //     />
    //     <Route key={location.key} path="/work-type" component={WorkType} />
    //     <Route key={location.key} path="/visa-type-price" component={VisaTypePrice} />
    //     <Route key={location.key} path="/service-type" component={ServiceType} />
    //     <Route key={location.key} path="/nz-form-list" component={NzFormList} />
    //     <Route key={location.key} path="/aus-form-list" component={AusFormList} />
    //     <Route key={location.key} path="/technical-support" component={TechnicalSupport} />
    //     <Route key={location.key} path="/meetings" component={ComingSoon} />
    //     <Route key={location.key} path="/admission" component={Admission} />
    //     <Route key={location.key} path="/client-email" component={ClientEmail} />
    //     <Route key={location.key} path="/custom-questionnaire" component={CustomQuestionnaire} />
    //     <Route key={location.key} path="/questionnaire" component={QuestionnaireList} />
    //     <Route key={location.key} path="/preview-questionnaire" component={PreviewQuestionnaire} />
    //     <Route key={location.key} path="/school-management" component={SchoolManagementLayout} />
    //     <Route key={location.key} path="/school-management/student-list" component={StudentList} />
    //     <Route key={location.key} path="/school-management/schools" component={Schools} />
    //     <Route key={location.key} path="/school-management/new-invoice" component={NewInvoice} />
    //     <Route key={location.key} path="/school-management/accounts" component={SchoolAccounts} />
    //     <Route key={location.key} path="/client-tags" component={ClientTags} />
    //     <Route key={location.key} path="/document-types" component={DocumentTypes} />
    //     <Route key={location.key} path="/ezm-common-docs" component={EzmCommonDocs} />
    //     <Route key={location.key} path="/reminder-setting" component={ReminderSetting} />
    //     <Route key={location.key} path="/time-tracking-setting" component={SettingTimeTracking} />
    //     <Route
    //       key={location.key}
    //       path="/visa-update-notificaton"
    //       component={VisaUpdateNotification}
    //     />
    //     <Route key={location.key} path="/document-checklist" component={DocumentChecklist} />
    //     <Route key={location.key} path="/file-notes-settings" component={SettingFileNotes} />
    //     <Route key={location.key} path="/contract-settings" component={ContractSettings} />
    //     <Route key={location.key} path="/letter-templates-settings" component={LetterTemplates} />
    //     <Route key={location.key} path="/mail-chimp-settings" component={MailChamp} />
    //     <Route
    //       key={location.key}
    //       path="/agent-portal-document-settings"
    //       component={AgentPortalDocuments}
    //     />
    //     <Route key={location.key} path="/check-my-visa-settings" component={CheckMyVisaDocs} />
    //     <Route key={location.key} path="/email-content" component={EmailContent} />
    //     <Route
    //       key={location.key}
    //       path="/questionnaire-settings"
    //       component={QuestionnaireSettings}
    //     />
    //     <Route key={location.key} path="/default-font-settings" component={DefaultFontSettings} />
    //     <Route key={location.key} path="/time-zone-settings" component={TimeZoneSettings} />
    //     <Route key={location.key} path="/signature-settings" component={SignatureSettings} />
    //     <Route key={location.key} path="/daily-email-settings" component={DailyEmailSettings} />
    //     <Route key={location.key} path="/deals" component={Deals} />
    //     {/* <Route path="/profile-client-tags" component={ProfileSidebar} /> */}
    //     <Route
    //       // key={location.key}
    //       path="/questionnaire-form"
    //       component={SubmitQuestionnaire}
    //     />
    //     <Route
    //       // key={location.key}
    //       path="/update-questionnaire"
    //       component={UpdateQuestionnaire}
    //     />
    //     <Route
    //       // key={location.key}
    //       path="/update-mapp-property"
    //       component={UpdateMappProperty}
    //     />
    //     <Route key={location.key} path="/document-view-settings" component={DocumentView} />
    //     <Route key={location.key} path="/imap-settings" component={ImapSettings} />
    //     <Route key={location.key} path="/document-sync" component={DocumentSync} />
    //     <Route key={location.key} path="/outlook-integration" component={OutlookIntegration} />
    //     <Route key={location.key} path="/graph-integration" component={OutlookIntegrationNew} />
    //     <Route key={location.key} path="/calender-settings" component={CalendarSync} />
    //     <Route
    //       key={location.key}
    //       path="/client-questionnaire"
    //       component={(props) => <ClientQuestionnaire {...props} />}
    //     />
    //     {/* <Route path="/c_q" component={LinkQuestionnaire} /> */}
    //     <Route key={location.key} path="/accounts" component={Accounts} />
    //     <Route key={location.key} path="/accounts/templates" component={Listing} />
    //     <Route key={location.key} path="/accounts/client-list" component={ClientList} />
    //     <Route key={location.key} path="/document-link-client/:id" component={ContactUs} />
    //     <Route
    //       exact
    //       path="/client-family-member"
    //       render={() => <FamilyMember key={location.key} />}
    //     />
    //     <Route key={location.key} path="/chats" component={ComingSoon} />
    //     <Route key={location.key} path="/companies" component={Companies} />
    //     <Route key={location.key} path="/company-user" component={CompanyUsersList} />
    //     <Route key={location.key} path="/login-image" component={LoginImage} />
    //     <Route key={location.key} path="/Branch-Detail" component={BranchDetail} />
    //     <Route key={location.key} exact path="/xero-sync" component={Xero} />
    //     <Route
    //       key={location.key}
    //       exact
    //       path="/xero-sync-add-account"
    //       component={XeroAddAccountLayout}
    //     />
    //     <Route key={location.key} exact path="/xero-sync-invoices" component={Invoices} />
    //     <Route key={location.key} exact path="/xero-sync-invoice" component={AddInvoiceToXero} />
    //     <Route
    //       key={location.key}
    //       exact
    //       path="/xero-sync-invoice-payments"
    //       component={AddPaymentsToXero}
    //     />
    //     <Route
    //       exact
    //       key={location.key}
    //       path="/xero-sync-school-invoice"
    //       component={AddSchoolInvoiceToXero}
    //     />
    //     <Route path="/email" component={Mail} />
    //     <Route
    //       key={location.key}
    //       exact
    //       path="/agreement"
    //       render={() => (window.location.href = '../../AgreementBuilder/index.html')}
    //     />
    //     <Route
    //       exact
    //       key={location.key}
    //       path="/potential-client-questionnaire"
    //       component={PCleintCustomQuestionnaire}
    //     />
    //     <Route key={location.key} exact path="/client-other-info" component={OtherInfo} />
    //     /* Supervisor routes */
    //     <Route key={location.key} exact path="/supervisor/batches" component={Supervisor} />
    //     <Route
    //       key={location.key}
    //       exact
    //       path="/supervisor/batches/students"
    //       component={SupervisorBatchesStudents}
    //     />
    //     <Route
    //       key={location.key}
    //       exact
    //       path="/supervisor/batches/upload-data"
    //       component={UploadStudentData}
    //     />
    //     <Route exact path="/print-case" component={PrintCase} />
    //     <Route key={location.key} exact path="/not-allowed" component={PurchaseSubscription} />
    //     {/* <Route exact path="/Home/PrivacyPolicy" component={PrivacyPolicy} /> */}
    //     {/* redirect user to SignIn page if route does not exist and user is not authenticated */}
    //     {/* <Route key={location.key} component={Profile} /> */}
    //   </Switch>
    // </Suspense>
    <Switch>
      <LazyRoute exact path="/dashboardBI" component={DashboardBi} />
      <LazyRoute path="/all-clients" component={AllClients} />
      <LazyRoute path="/visa-flow" component={VisaFlow} />
      <LazyRoute path="/documents" component={ClientDocument} />
      <LazyRoute path="/employer" component={Employer} />
      <LazyRoute path="/job-history" component={JobHistory} />
      <LazyRoute path="/qualification" component={Qualification} />
      <LazyRoute path="/client-account" component={ClientAccount} />
      <LazyRoute path="/potential-client" component={Inquiry} />
      <LazyRoute path="/import-potential-client" component={ImportPotentialClient} />
      <LazyRoute path="/add-potential-client" component={AddNewPotentialClient} />
      <LazyRoute path="/update-potential-client" component={AddNewPotentialClient} />
      <LazyRoute exact path="/potential-client/potential-clients" component={PotentialClient} />
      <LazyRoute
        exact
        path="/potential-client/potential-clients-status"
        component={PotentialClientsStatus}
      />
      <LazyRoute exact path="/potential-client/potential-employer" component={PotentialEmployer} />
      <LazyRoute exact path="/add-new-client" component={AddNewClient} />
      <LazyRoute path="/file-notes" component={FileNotes} />
      <LazyRoute path="/activities" component={Activities} />
      <LazyRoute exact path="/profile" component={Profile} />
      <LazyRoute exact path="/partner-profile" component={Partner} />
      <LazyRoute exact path="/dashboard" component={ClientSummary} />
      <LazyRoute
        exact
        path="/dashboard/potentialclient"
        component={DashboardPotentialClientReport}
      />
      <LazyRoute exact path="/dashboard/reminders" component={DashboardReminders} />
      <LazyRoute exact path="/dashboard/employers" component={DashboardEmployers} />
      <LazyRoute exact path="/dashboard/student" component={DashboardStudent} />
      <LazyRoute path="/Case-Management-All" component={CaseManagement} />
      <LazyRoute path="/Case-management" component={CaseManagement} />
      <LazyRoute path="/AddChecklist" component={AddChecklist} />
      <LazyRoute path="/Checklists" component={ChecklistCategory} />
      <LazyRoute path="/super-user-setting" component={UserDetail} />
      <LazyRoute path="/team-member" component={TeamMember} />
      <LazyRoute path="/add-agent" component={AddAgent} />
      <LazyRoute path="/branch-settings" component={BranchSetting} />
      <LazyRoute path="/visa-type" component={VisaType} />
      <LazyRoute path="/visa-branch-country" component={VisaBranchCountry} />
      <LazyRoute path="/visa-statuses" component={VisaStatus} />
      <LazyRoute path="/potential-client-status" component={PotentialClientStatus} />
      <LazyRoute exact path="/account-setting" component={ImapSettings} />
      <LazyRoute exact path="/account-setting-gmail" component={GmailIntegration} />
      <LazyRoute exact path="/account-setting-hubspot" component={HubspotIntegration} />
      <LazyRoute path="/account-settings" component={AccountSetting} />
      <LazyRoute path="/reports" component={Reports} />
      <LazyRoute path="/potential-clients-report" component={PotentialClientReport} />
      <LazyRoute path="/visa-report" component={VisaReport} />
      <LazyRoute path="/time-tracking" component={TimeTrackingMain} />
      <LazyRoute path="/time-tracking-report" component={TimeTrackingReport} />
      <LazyRoute path="/employer-reports" component={EmployerReports} />
      <LazyRoute path="/agents" component={Agents} />
      <LazyRoute path="/agent-clients" component={ComingSoon} />
      <LazyRoute path="/video-tutorials" component={Videos} />
      <LazyRoute path="/useful-links" component={ComingSoon} />
      <LazyRoute path="/employer-management" component={EmployerManagementHead} />
      <LazyRoute path="/web-assessment" component={WebAssessment} />
      <LazyRoute path="/web-inquiry-detailed" component={WebInquiryDetailed} />
      <LazyRoute path="/web-inquiry-link-detailed" component={WebInquiryLinkDetailed} />
      <LazyRoute path="/web-inquiry-link-basic" component={WebInquiryLinkBasic} />
      <LazyRoute path="/web-assessment-link" component={WebAssessmentLink} />
      <LazyRoute path="/basic-assessment-link" component={BasicAssessmentLink} />
      <LazyRoute path="/tasks-and-reminders" component={DailyTaskReminders} />
      <LazyRoute path="/tasks-and-reminders/tasks-to-do" component={DailyTaskReminders} />
      <LazyRoute path="/tasks-and-reminders/completed-tasks" component={CompletedTasks} />
      <LazyRoute path="/tasks-and-reminders/commission-reminders" component={CommissionReminder} />
      <LazyRoute path="/work-type" component={WorkType} />
      <LazyRoute path="/visa-type-price" component={VisaTypePrice} />
      <LazyRoute path="/service-type" component={ServiceType} />
      <LazyRoute path="/nz-form-list" component={NzFormList} />
      <LazyRoute path="/aus-form-list" component={AusFormList} />
      <LazyRoute path="/technical-support" component={TechnicalSupport} />
      <LazyRoute path="/meetings" component={ComingSoon} />
      <LazyRoute path="/admission" component={Admission} />
      <LazyRoute path="/client-email" component={ClientEmail} />
      <LazyRoute path="/custom-questionnaire" component={CustomQuestionnaire} />
      <LazyRoute path="/questionnaire" component={QuestionnaireList} />
      <LazyRoute path="/preview-questionnaire" component={PreviewQuestionnaire} />
      <LazyRoute path="/school-management" component={SchoolManagementLayout} />
      <LazyRoute path="/school-management/student-list" component={StudentList} />
      <LazyRoute path="/school-management/schools" component={Schools} />
      <LazyRoute path="/school-management/new-invoice" component={NewInvoice} />
      <LazyRoute path="/school-management/accounts" component={SchoolAccounts} />
      <LazyRoute path="/client-tags" component={ClientTags} />
      <LazyRoute path="/document-types" component={DocumentTypes} />
      <LazyRoute path="/ezm-common-docs" component={EzmCommonDocs} />
      <LazyRoute path="/reminder-setting" component={ReminderSetting} />
      <LazyRoute path="/time-tracking-setting" component={SettingTimeTracking} />
      <LazyRoute path="/visa-update-notificaton" component={VisaUpdateNotification} />
      <LazyRoute path="/document-checklist" component={DocumentChecklist} />
      <LazyRoute path="/file-notes-settings" component={SettingFileNotes} />
      <LazyRoute path="/contract-settings" component={ContractSettings} />
      <LazyRoute path="/letter-templates-settings" component={LetterTemplates} />
      <LazyRoute path="/mail-chimp-settings" component={MailChamp} />
      <LazyRoute path="/agent-portal-document-settings" component={AgentPortalDocuments} />
      <LazyRoute path="/check-my-visa-settings" component={CheckMyVisaDocs} />
      <LazyRoute path="/email-content" component={EmailContent} />
      <LazyRoute path="/questionnaire-settings" component={QuestionnaireSettings} />
      <LazyRoute path="/default-font-settings" component={DefaultFontSettings} />
      <LazyRoute path="/time-zone-settings" component={TimeZoneSettings} />
      <LazyRoute path="/signature-settings" component={SignatureSettings} />
      <LazyRoute path="/daily-email-settings" component={DailyEmailSettings} />
      <LazyRoute path="/deals" component={Deals} />
      <LazyRoute path="/questionnaire-form" component={SubmitQuestionnaire} />
      <LazyRoute path="/update-questionnaire" component={UpdateQuestionnaire} />
      <LazyRoute path="/update-mapp-property" component={UpdateMappProperty} />
      <LazyRoute path="/document-view-settings" component={DocumentView} />
      <LazyRoute path="/imap-settings" component={ImapSettings} />
      <LazyRoute path="/document-sync" component={DocumentSync} />
      <LazyRoute path="/outlook-integration" component={OutlookIntegration} />
      <LazyRoute path="/graph-integration" component={OutlookIntegrationNew} />
      <LazyRoute path="/calender-settings" component={CalendarSync} />
      <LazyRoute path="/client-questionnaire" component={ClientQuestionnaire} />
      <LazyRoute path="/accounts" component={Accounts} />
      <LazyRoute path="/accounts/templates" component={Listing} />
      <LazyRoute path="/accounts/client-list" component={ClientList} />
      <LazyRoute path="/document-link-client/:id" component={ContactUs} />
      <LazyRoute exact path="/client-family-member" component={FamilyMember} />
      <LazyRoute path="/chats" component={ComingSoon} />
      <LazyRoute path="/companies" component={Companies} />
      <LazyRoute path="/ezy-ai-companies" component={KnockKnockCompanies} />
      <LazyRoute exact path="/ezy-ai" component={KnockKnockPortal} />
      <LazyRoute exact path="/knockknock-docs" component={KnockKnockDocsPage} />
      <LazyRoute path="/company-user" component={CompanyUsersList} />
      <LazyRoute path="/login-image" component={LoginImage} />
      <LazyRoute path="/Branch-Detail" component={BranchDetail} />
      <LazyRoute exact path="/xero-sync" component={Xero} />
      <LazyRoute exact path="/xero-sync-add-account" component={XeroAddAccountLayout} />
      <LazyRoute exact path="/xero-sync-invoices" component={Invoices} />
      <LazyRoute exact path="/xero-sync-invoice" component={AddInvoiceToXero} />
      <LazyRoute exact path="/xero-sync-invoice-payments" component={AddPaymentsToXero} />
      <LazyRoute exact path="/xero-sync-school-invoice" component={AddSchoolInvoiceToXero} />
      <LazyRoute path="/email" component={Mail} />
      <LazyRoute
        exact
        path="/agreement"
        render={() => (window.location.href = '../../AgreementBuilder/index.html')}
      />
      <LazyRoute
        exact
        path="/potential-client-questionnaire"
        component={PCleintCustomQuestionnaire}
      />
      <LazyRoute exact path="/client-other-info" component={OtherInfo} />
      <LazyRoute exact path="/supervisor/batches" component={Supervisor} />
      <LazyRoute exact path="/supervisor/batches/students" component={SupervisorBatchesStudents} />
      <LazyRoute exact path="/supervisor/batches/upload-data" component={UploadStudentData} />
      <LazyRoute exact path="/print-case" component={PrintCase} />
      <LazyRoute exact path="/not-allowed" component={PurchaseSubscription} />
      <LazyRoute exact path="/Home/PrivacyPolicy" component={PrivacyPolicy} />
      <LazyRoute path="/ai-workflow-studio" component={WorkflowStudio} />
      <LazyRoute path="/ai-workflow" component={WorkflowStudio} />
      <LazyRoute path="/ai-workflow-runs" component={WorkflowExecutions} />
      <LazyRoute path="/ai-workflow-executions" component={WorkflowExecutions} />
    </Switch>
  );
}
